module.exports = {
  pricePerVariationStatus: (parentVariation = {}) => {
    const { pricePerVariationRequestedAt, pricePerVariationEnabled } = parentVariation;
    return pricePerVariationEnabled ? 'enabled'
      : pricePerVariationRequestedAt == null ? 'initial'
      : 'requested';
  },
};
